import React, { useState } from 'react'

import ItemInvoiceComponent from './ItemInvoiceComponent'
import ModalComponent from './ModalComponent'

export const InvoiceAvaliable = ({ item, index }) => {
  const [isShowModal, setIsShowModal] = useState(false)

  return (
    <>
      <ItemInvoiceComponent
        index={index}
        status="disponível"
        buttonLabel={'Declarar renda'}
        item={item}
        setIsShowModal={setIsShowModal}
      />

      {isShowModal && <ModalComponent item={item} setIsShowModal={setIsShowModal} />}
    </>
  )
}
